/**
 * Do not edit directly
 */

export default "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48cGF0aCBkPSJNMTkuNSw1LjRMOC41LDE2LjRMNC41LDEyLjRMMy40LDEzLjVMOC41LDE4LjZMMjAuNiw2LjVMMTkuNSw1LjRaIi8+PC9zdmc+";